import { render, staticRenderFns } from "./SurveyStatisticsChart.vue?vue&type=template&id=3f4cd1a6&scoped=true&"
import script from "./SurveyStatisticsChart.vue?vue&type=script&lang=js&"
export * from "./SurveyStatisticsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4cd1a6",
  null
  
)

export default component.exports